






































































import Vue from 'vue';
import _ from 'lodash';
import { EmailCampaignSummary } from '@/types';
import { round } from '@/utils';
import SummaryCard from './SummaryCard.vue';

export default Vue.extend({
  props: {
    summary: {
      type: Object as () => EmailCampaignSummary,
      required: true,
    },
  },
  computed: {
    openRate(): number {
      const openRate = _.multiply(
        _.divide(this.summary.uniqueOpens, this.summary.recipients), 100,
      );
      return round(openRate);
    },
    clickThroughRate(): number {
      const clickThroughRate = _.multiply(
        _.divide(this.summary.clicks, this.summary.uniqueOpens), 100,
      );
      return round(clickThroughRate);
    },
    bounceRate(): number {
      const bounceRate = _.multiply(
        _.divide(this.summary.bounces, this.summary.recipients), 100,
      );
      return round(bounceRate);
    },
    unsubscribeRate(): number {
      const unsubscribeRate = _.multiply(
        _.divide(this.summary.unsubscribes, this.summary.recipients), 100,
      );
      return round(unsubscribeRate);
    },
    spamRate(): number {
      const unsubscribeRate = _.multiply(
        _.divide(this.summary.spamComplaints, this.summary.recipients), 100,
      );
      return round(unsubscribeRate);
    },
  },
  methods: {
    round(value: number): string {
      return round(value);
    },
  },
  components: {
    'summary-card': SummaryCard,
  },
});
